import { useState, useCallback } from "react";
import { clientReportService } from "../../services";

export const useClientReport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getClients = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await clientReportService.getClients(params);
      return result;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const getClientDetails = useCallback(async (clientId, params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const result = await clientReportService.getClientDetails(
        clientId,
        params,
      );
      return result.data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    getClients,
    getClientDetails,
  };
};
